import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=03d14936&"
import script from "./ssoLogin.vue?vue&type=script&lang=js&"
export * from "./ssoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports